// Discount-code staging.
//
// We can't validate codes against a cart — Shopify only validates at checkout.
// So this component just stages the code: sets the `discount_code` cookie
// (same mechanism Shopify's own `/discount/CODE` URL uses) and shows a neutral
// "will be applied at checkout" message. Checkout then validates and either
// applies it or surfaces the error there.
//
// URL-param ingestion (`?discount=CODE`) is handled on import so any link that
// drops the user on any page stages the code automatically.

import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

const COOKIE_NAME = 'discount_code'

function setDiscountCookie(code: string) {
	document.cookie = `${COOKIE_NAME}=${encodeURIComponent(code)}; path=/`
}

export class CartDiscount extends UcoastEl {
	static htmlSelector = 'cart-discount'
	input: HTMLInputElement
	form: HTMLFormElement
	message: HTMLElement | null

	constructor() {
		super()
		this.form = q.rs<HTMLFormElement>('form', this)
		this.input = q.rs<HTMLInputElement>('input', this)
		this.message = this.querySelector('[data-uc-cart-discount-message]')

		this.form.addEventListener('submit', this.onSubmit.bind(this))
	}

	onSubmit(event: Event) {
		event.preventDefault()
		const code = this.input.value.trim()
		if (!code) {
			this.setMessage('Enter a discount code.')
			return
		}
		setDiscountCookie(code)
		this.setMessage(`Code "${code}" will be applied at checkout.`)
	}

	setMessage(text: string) {
		if (this.message) this.message.textContent = text
	}
}

function ingestDiscountFromUrl() {
	if (typeof window === 'undefined') return

	const params = new URLSearchParams(window.location.search)
	const code = params.get('discount')?.trim()
	if (!code) return

	setDiscountCookie(code)

	// Strip the param so the discount isn't shared / re-ingested on reload
	params.delete('discount')
	const search = params.toString()
	const newUrl = window.location.pathname + (search ? `?${search}` : '') + window.location.hash
	window.history.replaceState({}, '', newUrl)
}

ingestDiscountFromUrl()
